export const getUser = () => {
  const userData = localStorage.getItem("Bu_user");
  if (userData !== null) {
    return JSON.parse(userData);
    // console.log(JSON.parse(userData));
  }
  return null;
};

export const getToken = () => {
  const token = localStorage.getItem("Bu_token");
  // console.log(token);
  if (token !== null) {
    return token;
  }
  return null;
};

export const userId = () => {
  const userId = localStorage.getItem("Bu_userId");
  if (userId !== null) {
    return userId;
  }
  return null;
};
export const enduserId = () => {
  const enduserId = localStorage.getItem("eu_userId");
  if (enduserId !== null) {
    return enduserId;
  }
  return null;
};

export const CityId = () => {
  const cityId = localStorage.getItem("Bu_cityId");
  if (cityId !== null) {
    return cityId;
  }
  return null;
};

export const GetSocialLoginToken = () => {
  const SlToken = localStorage.getItem("Bu_SlToken");

  if (SlToken !== null) {
    return SlToken;
  }
  return null;
};

export const GetSlUserName = () => {
  const userName = localStorage.getItem("Bu_FirstName");

  if (userName !== null) {
    return userName;
  }
  return null;
};

//////////////////////////////////////////////////// Set Item Local storage /////////////////////////////////////

export const setUserCredentials = (user) => {
  const token = user.jwt_token ? user.jwt_token : "";
  const UserId = user.user_id ? user.user_id : "";
  // const CityId = user.city_id ? user.city_id : "";


  localStorage.setItem("Bu_token", token);
  localStorage.setItem("Bu_userId", UserId);
  // localStorage.setItem("Bu_cityId", CityId);
  localStorage.setItem("is_switched", Boolean(false));

  localStorage.setItem("Bu_user", user ? JSON.stringify(user) : null);
};

export const SetUserSocialLoginCredentials = (val) => {
  const SlToken = val.jwt_token;
  const UserId = val.user_id;
  const UserName = val.business_name;

  localStorage.setItem("Bu_token", SlToken);
  localStorage.setItem("Bu_userId", UserId);
  localStorage.setItem("Bu_FirstName", UserName);
  localStorage.setItem("Bu_user", val ? JSON.stringify(val) : null);
};

////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const removeUserCredentials = () => {
  localStorage.removeItem("Bu_token");
  localStorage.removeItem("Bu_user");
  localStorage.removeItem("Bu_userId");
  localStorage.removeItem("eu_userId");
  localStorage.removeItem("Bu_FirstName");
  // localStorage.removeItem("Bu_SlToken");
  localStorage.removeItem("Bu_cityId");
  localStorage.removeItem("ProfileImage");
  localStorage.removeItem("colName");
  localStorage.removeItem("sortval");
  // localStorage.removeItem("search");
  // localStorage.clear();
};

////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const RemoveSortkeys = () => {
  localStorage.removeItem("colName");
  localStorage.removeItem("sortval");
  // localStorage.removeItem("search");
};

// SET
export const setBusinessSwitched = (value) => {
  // console.log("value", value);
  localStorage.setItem("is_switched", value === true ? true : false);
};
// GET
export const getBusinessSwitched = () => {
  return localStorage.getItem("is_switched");
};

// for bussines active_business_id set

export const setactiveBuId = (value) => {
  //  console.log("get idd", value);
  localStorage.setItem("active_business_id", value);
 
};

// for bussines active_business_id GET
export const getactiveBuId = () => {
  return localStorage.getItem("active_business_id");
};
